<template>
  <div :class="['modal-overlay', { show: show }]" v-show="show" @click.self="handleSelfClick">
    <div class="modal-container" :class="{ 'modal-enter-active': show }">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <div class="modal-title-section">
            <div class="title-icon">
              <i class="bi bi-exclamation-triangle-fill"></i>
            </div>
            <div class="modal-title-content">
              <h2 class="modal-title">{{ title }}</h2>
              <div class="modal-subtitle">Exodous I.T. Solutions</div>
            </div>
          </div>
          <button @click="close" type="button" class="close-btn" aria-label="Close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="body-content">
            <slot />
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <div class="footer-actions">
            <div class="footer-info">
              <i class="bi bi-shield-check"></i>
              Secure Connection
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    dismissable:{
      type:Boolean,
      default: true
    },
    title: {
      type: String,
      default() {
        return "Business Information";
      },
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };
    const handleSelfClick = ()=>{
        if(props.dismissable)
        close();
    };

    return {
      close,
      handleSelfClick
    };
  },
};
</script>

<style scoped>
/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  z-index: 1050;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.modal-overlay.show {
  opacity: 1;
  visibility: visible;
}

/* Modal Container */
.modal-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.8);
  width: 95%;
  height: 90%;
  max-width: 1200px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.1),
    0 0 100px rgba(163, 14, 14, 0.1);
  z-index: 1060;
  opacity: 0;
  transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.modal-container.modal-enter-active {
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}

/* Modal Content */
.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 20px;
  overflow: hidden;
}

/* Modal Header */
.modal-header {
  background: linear-gradient(135deg, #a30e0e 0%, #8a0b0b 100%);
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.6) 50%,
    transparent 100%
  );
  animation: shimmer 3s ease-in-out infinite;
}

.modal-title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.title-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  animation: pulse 2s ease-in-out infinite;
}

.title-icon i {
  font-size: 1.5rem;
  color: white;
}

.modal-title-content {
  color: white;
}

.modal-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.modal-subtitle {
  font-size: 0.85rem;
  opacity: 0.9;
  margin-top: 0.25rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Close Button */
.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.close-btn:active {
  transform: scale(0.95);
}

/* Modal Body */
.modal-body {
  flex: 1;
  padding: 0;
  overflow: hidden;
  background: #ffffff;
}

.body-content {
  height: 100%;
  overflow-y: auto;
  padding: 2rem;
  background: radial-gradient(
      circle at 20% 80%,
      rgba(163, 14, 14, 0.03) 0%,
      transparent 50%
    ),
    radial-gradient(circle at 80% 20%, rgba(163, 14, 14, 0.03) 0%, transparent 50%);
}

/* Custom Scrollbar for Body */
.body-content::-webkit-scrollbar {
  width: 8px;
}

.body-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.body-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #a30e0e, #8a0b0b);
  border-radius: 4px;
}

.body-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #8a0b0b, #700000);
}

/* Modal Footer */
.modal-footer {
  background: #f8f9fa;
  padding: 1.25rem 2rem;
  border-top: 1px solid #e9ecef;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.footer-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d, #5a6268);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 10px rgba(108, 117, 125, 0.2);
}

.btn-secondary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

.btn-secondary:active {
  transform: translateY(0);
}

.footer-info {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6c757d;
  font-size: 0.85rem;
  font-weight: 500;
}

.footer-info i {
  color: #28a745;
}

/* Animations */
@keyframes shimmer {
  0%,
  100% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 40px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .modal-container {
    width: 98%;
    height: 95%;
    border-radius: 16px;
  }

  .modal-header {
    padding: 1.25rem 1.5rem;
  }

  .modal-title {
    font-size: 1.25rem;
  }

  .title-icon {
    width: 40px;
    height: 40px;
  }

  .title-icon i {
    font-size: 1.25rem;
  }

  .body-content {
    padding: 1.5rem;
  }

  .modal-footer {
    padding: 1rem 1.5rem;
  }

  .footer-actions {
    flex-direction: column;
    gap: 1rem;
    align-items: stretch;
  }

  .btn-secondary {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .modal-title-section {
    flex-direction: column;
    text-align: center;
  }

  .body-content {
    padding: 1rem;
  }
}

/* Backdrop Animation */
.modal-overlay.show::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
    circle at center,
    rgba(163, 14, 14, 0.1) 0%,
    transparent 70%
  );
  animation: backdropPulse 4s ease-in-out infinite;
}

@keyframes backdropPulse {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}

/* Enhanced focus states for accessibility */
.close-btn:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
}

.btn-secondary:focus {
  outline: 2px solid rgba(108, 117, 125, 0.5);
  outline-offset: 2px;
}
</style>
